export default {
  greet: 'Selamat Datang!',
  question: 'Mau kirim barang kemana hari ini?',
  originLoc: 'Lokasi Asal',
  destinationLoc: 'Lokasi Akhir',
  errorLocation: 'Harap mengisi lokasi dengan benar',
}
